import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";

export const databaseToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [
    HOST_TOOL_NAMES.DETECT_PROJECT_DATABASE,
    () => labelOnly("Recorded the project database"),
  ],
  [
    HOST_TOOL_NAMES.BIND_PROJECT_DATABASE,
    () => labelOnly("Requested approval to bind the project database"),
  ],
  [
    HOST_TOOL_NAMES.REQUEST_DATABASE_URL,
    () => labelOnly("Asked for the production database URL"),
  ],
  [
    HOST_TOOL_NAMES.DATABASE_QUERY,
    (record) => {
      const branch = toolInput.trimmed(record.branch) ?? "production";
      const sql = toolInput.verbatim(record.sql);
      return sql
        ? { text: `Read the database (${branch})`, command: sql }
        : labelOnly(`Read the database (${branch})`);
    },
  ],
  [
    HOST_TOOL_NAMES.DATABASE_WRITE,
    (record) => {
      const branch = toolInput.trimmed(record.branch) ?? "production";
      const sql = toolInput.verbatim(record.sql);
      return sql
        ? {
            text: `Requested approval to write to the database (${branch})`,
            command: sql,
          }
        : labelOnly(`Requested approval to write to the database (${branch})`);
    },
  ],
];
